/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/moduleConfiguration/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* loadModuleConfiguration({ callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: 'module-configurations' });
    yield put({
      type: TypeActions.FETCH_MODULE_CONFIGURATION_SUCCESS,
      data: response.data
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    if (callback) {
      callback(true);
    }
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!'
    });
    if (callback) {
      callback(false);
    }
  }
}

export default function* watchAuth() {
  yield takeLatest(TypeActions.FETCH_MODULE_CONFIGURATION, loadModuleConfiguration);
}
